import Browser from '@mindful-web/marko-web/browser';
import Global from '@cox-matthews-associates/package-global/browser';

Global(Browser);

export default Browser;
